import React from "react";
import "./deletedialog.scss";
import trash from "../../../../assets/icons/trash.png";
import { CloseSVG } from "../../../../assets/icons";
function DeleteDialog({ onDelete, onCancel, title, cancel, deletes }: any) {
  return (
    <div className="deletedialog">
      <div className="container">
        <span onClick={() => onCancel()}>
          <CloseSVG />
        </span>
        <div className="header">
          <img src={trash} alt="" />
          <h4>
            {title ??
              "Are you sure you want to deactivate this patient's record?"}
          </h4>
        </div>
        {/* <h4>Delete blog post</h4> */}
        <div className="butons">
          <button onClick={() => onCancel()}>{cancel ?? "CANCEL"}</button>
          <button onClick={() => onDelete()}>{deletes ?? "DEACTIVE"}</button>
        </div>
      </div>
    </div>
  );
}

export default DeleteDialog;
